import { useEffect, useState } from "react";
import { api } from "../../lib/auth";

function StatusPill({ status }) {
  const styles = {
    verified: "bg-[#E8F5E9] text-[#1FA868]",
    pending: "bg-[#FFF5D6] text-amber-700",
    failed: "bg-rose-50 text-rose-600",
  };

  return (
    <span className={`text-[10px] font-bold uppercase px-2.5 py-1 rounded-md ${styles[status] || "bg-black/5 text-black/60"}`}>
      {(status || "").replace("_", " ")}
    </span>
  );
}

export default function AdminTransactions() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/transactions").then((r) => setRows(r.data));
  }, []);

  // 📊 Stats
  const total = rows.length;
  const success = rows.filter((t) => t.status === "verified").length;
  const volume = rows.reduce((sum, t) => sum + (t.amount || 0), 0);

  return (
    <div className="p-8 lg:p-10 max-w-[1400px] space-y-6">

      {/* 🔥 Header */}
      <div>
        <h1 className="font-display font-extrabold text-4xl text-black tracking-tight">
          Transactions
        </h1>
        <p className="text-black/60 mt-1 text-sm">
          Track all payment activity across tenants.
        </p>
      </div>

      {/* 📊 Stats */}
      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-[#EEF6FF] rounded-2xl p-5 border border-black/5">
          <div className="text-xs text-black/50">Total Transactions</div>
          <div className="text-2xl font-bold text-black mt-1">{total}</div>
        </div>

        <div className="bg-[#E8F5E9] rounded-2xl p-5 border border-black/5">
          <div className="text-xs text-black/50">Successful</div>
          <div className="text-2xl font-bold text-[#1FA868] mt-1">{success}</div>
        </div>

        <div className="bg-[#FFF5D6] rounded-2xl p-5 border border-black/5">
          <div className="text-xs text-black/50">Total Volume</div>
          <div className="text-2xl font-bold text-black mt-1">
            ₦{volume.toLocaleString()}
          </div>
        </div>
      </div>

      {/* 📋 Table */}
      <div className="bg-white rounded-2xl border border-black/8 overflow-hidden shadow-sm">

        {/* Table header */}
        <div className="px-6 py-4 border-b border-black/8 flex items-center justify-between">
          <h2 className="font-semibold text-black">All Transactions</h2>
          <span className="text-xs text-black/50">{rows.length} records</span>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#FAFAFA] text-black/55 text-[11px] uppercase tracking-wider">
              <tr>
                <th className="text-left px-6 py-3 font-bold">Tenant</th>
                <th className="text-left px-6 py-3 font-bold">Reference</th>
                <th className="text-left px-6 py-3 font-bold">Method</th>
                <th className="text-left px-6 py-3 font-bold">Amount</th>
                <th className="text-left px-6 py-3 font-bold">Status</th>
                <th className="text-left px-6 py-3 font-bold">Date</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-black/5">
              {rows.map((t) => (
                <tr key={t.id} className="hover:bg-[#F9FAFB] transition">
                  
                  <td className="px-6 py-4 font-semibold text-black">
                    {t.tenant}
                  </td>

                  <td className="px-6 py-4 font-mono text-xs text-black/60">
                    {t.reference}
                  </td>

                  <td className="px-6 py-4 text-black/70 capitalize">
                    {(t.method || "").replace("_", " ")}
                  </td>

                  <td className="px-6 py-4 font-semibold tabular-nums">
                    ₦{Number(t.amount || 0).toLocaleString()}
                  </td>

                  <td className="px-6 py-4">
                    <StatusPill status={t.status} />
                  </td>

                  <td className="px-6 py-4 text-black/50 text-xs">
                    {(t.date || "").slice(0, 10)}
                  </td>

                </tr>
              ))}

              {rows.length === 0 && (
                <tr>
                  <td colSpan="6" className="p-12 text-center text-black/50">
                    No transactions yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}